<template>
  <div class="con_inner" v-if="data.reportCount == 0">
    <div class="con_box">
      <div class="con__left">
        <ul>
          <li class="red" v-if="data.isHot === 'Y'">HOT</li>
          <li class="red02" v-if="isNew(data.createdAt)">NEW</li>
          <li v-if="data.category">{{ categories[data.category] }}</li>
        </ul>
        <h3 v-html="colorWord(data.title)"></h3>
        <p class="txt" v-html="colorWord(data.contents)"></p>
      </div>
      <div class="con__right" v-if="data.imagePath">
        <img :src="data.imagePath" alt="" />
      </div>
    </div>
    <hr />
    <div class="info_zone">
      <div class="sec_2">
        <div class="left">
          <span>{{ data.createdAt | moment('from') }}</span>
          <span>{{ data.writer }}</span>
        </div>
        <div class="right">
          <span><i class="i_list_like"></i>{{ data.likeCnt }}</span>
          <span><i class="i_list_eye"></i>{{ data.readCnt }}</span>
          <span><i class="i_list_reply"></i>{{ data.replyCnt }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="con_inner" v-else>
    <div class="con_box">
      <div class="con__left">
        <p class="txt">신고가 접수되어 임시 블라인드 처리된 게시물 입니다.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { setKeyword } from '@common/lib/common/utils';

export default {
  name: 'component-community-list-item',
  description: '커뮤니티 > 리스트 아이템',
  props: {
    boardType: {
      type: String,
      default: 'KNOWHOW',
      description: 'KNOWHOW: 지식인, BOARD: 자유게시판',
    },
    data: Object,
  },
  data() {
    return {
      categories: {
        MOBILE: '휴대폰',
        INTERNET: '인터넷',
        MVNO: '알뜰폰',
        PLAN: '요금제',
        RENTAL: '렌탈',
        STORE: '매장',
      },
    };
  },
  methods: {
    isNew(createdAt) {
      const now = this.$moment().format('YYYY-MM-DD HH:mm:ss');
      const create_24 = this.$moment(createdAt)
        .add(1, 'days')
        .format('YYYY-MM-DD HH:mm:ss');
      return now < create_24;
    },
    colorWord(content) {
      const keyword = this.$route.query.keyword;
      return setKeyword(content, keyword);
    },
  },
};
</script>

<style></style>
